module.exports = __webpack_public_path__ + "static/img/1_0045.5424482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0045.jpg
// module id = 8LcJ
// module chunks = 0